import React from 'react';
import _ from 'lodash';

import { DisplayDate, DisplayTime } from '@tock/time';
import { ExperienceOption } from 'components/business/waitlist-dialog/WaitlistDialog';
import { FormBlock, Typography } from 'omakase';
import Field from '@tock/shared/components/forms/Field';
import IsoCountryCodes from 'constants/IsoCountryCodes';
import OldTextInput from '@tock/shared/components/inputs/DeprecatedTextInput';
import PhoneFieldset from '@tock/shared/components/forms/fieldsets/PhoneFieldset';
import Select from '@tock/shared/components/inputs/Select';
import connect, { DefaultConnectProps } from '@tock/shared/utils/connect';

interface Props {
  email: ReduxFormField<string>;
  firstName: ReduxFormField<string>;
  isoCountryCode: ReduxFormField<string>;
  lastName: ReduxFormField<string>;
  phone: ReduxFormField<string>;
  phoneCountryCode: ReduxFormField<string>;
  selectedDate: ReduxFormArrayField<string>;
  selectedDesiredStartTime: string;
  selectedDesiredEndTime: string;
  selectedExperience: ExperienceOption;
  selectedPartySize: SelectOption;
  submitting: boolean;
}

const WaitlistDialogContactPage: React.FC<Props & DefaultConnectProps> = (props) => {
  const {
    actions,
    email,
    firstName,
    lastName,
    isoCountryCode,
    phone,
    phoneCountryCode,
    selectedDate,
    selectedDesiredStartTime,
    selectedDesiredEndTime,
    selectedExperience,
    selectedPartySize,
    submitting,
  } = props;

  const dateInfo =
    _.isArray(selectedDate.value) && selectedDate.value.length > 1 ? (
      'Multiple dates'
    ) : (
      <DisplayDate dateValue={selectedDate.value[0]} displayMonthAs="long" />
    );

  return (
    <FormBlock showDivider={false}>
      <Typography color="inherit" component="span" variant="body02">
        You're interested in {selectedExperience.label} for {selectedPartySize.label}
        {` from `}
        <DisplayTime timeValue={selectedDesiredStartTime} />
        {` - `}
        <DisplayTime timeValue={selectedDesiredEndTime} />
        {` on `}
        {dateInfo}
      </Typography>

      <Field labelFor="firstName" label="First name" field={firstName}>
        <OldTextInput
          id="firstName"
          field={firstName}
          disabled={submitting}
          autoComplete="given-name"
          placeholder="First name"
        />
      </Field>

      <Field labelFor="lastName" label="Last name" field={lastName}>
        <OldTextInput
          id="lastName"
          field={lastName}
          disabled={submitting}
          autoComplete="family-name"
          placeholder="Last name"
        />
      </Field>

      <Field labelFor="email" label="Email" field={email}>
        <OldTextInput
          id="email"
          autoComplete="email"
          disabled={submitting}
          field={email}
          placeholder="Email address"
          type="email"
        />
      </Field>

      <PhoneFieldset
        key="phone-fields"
        phone={phone}
        phoneCountryCode={phoneCountryCode}
        disabled={submitting}
        onValidatePhoneRequest={actions.patron.validatePhoneRequest}
      />

      <Field label="Country" labelFor="isoCountryCode" field={isoCountryCode}>
        <Select
          id="isoCountryCode"
          placeholder="Country"
          field={isoCountryCode}
          options={IsoCountryCodes}
        />
      </Field>
    </FormBlock>
  );
};

export default connect<Props>(WaitlistDialogContactPage);
